import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Proveedor } from "./proveedorModel";
import { Usuario } from "./usuarioModel";
import { notificacionesRq } from "./notificacionesModel";

@Injectable({
  providedIn: "root",
})
export class ProveedoresService {
  constructor(private http: HttpClient) {}

  getTiposPersona() {
     return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposPersona`);
  }

  getTiposDocumento(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposDoc`);
  }

  getProvincias(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboProvincias`);
  }

  getRubros(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposRubro`);
  }

  getTiposBenef(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposBenef`)
  }

  cargarCatBenef(tipoBenef : number){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboCatTiposBenef/${tipoBenef}`);
  }

  cargarDepartamentos(provincia : number){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboDepartamentos/${provincia}`);
  }

  addProveedor(data : Proveedor):Observable<any>{
    return this.http.post<any>(`${environment.urlProveedores}/InsertarProveedor`,data);
  }

  verificarProveedor(cuit : string):Observable<any>{
    return this.http.get<any>(`https://ambiente.sigemyt.com/afipApi/api/personas/datos?cuit=${cuit}`);
  }
  obtenerUsuario(cuil:string):Observable<any>{
    return this.http.get<any>(`${environment.urlUsuario}/Usuario/${cuil}`);
  }
  obtenerToken(usuario:Usuario){
     return this.http.post<any>(`https://ambiente.sigemyt.com/apiUsuario/api/GetUsuario/Token`,usuario);
  }
  logiarte(token:string):Observable<any>{
    
    return this.http.get<any>(`https://www.sigemyt.com/emisiondeudamlcapi/api/Seguridad/Login?atoken=${token}`);
  }
 
  irDeclaracionJurado(nroCuenta:number):Observable<any>{
    //nroCuenta = 27371149444;
    return this.http.post<any>(`https://www.sigemyt.com/ingresosmlc//ComercioeIndustria/DeclaWeb.aspx/getCuenta`,nroCuenta);
  }
  validarUsuario(usuario:Usuario):Observable<any>{
    return this.http.post<any>(`${environment.urlUsuario}/ValidarUsuario`,usuario);
  }

  obtenerCorreos(idPersona:string){
     return this.http.get<any>(`https://ambiente.sigemyt.com/apiUsuario/api/GetUsuario/obtenerCorreo/${idPersona}`);
  
  }

  actualizarNotificacionesLeidas(notificacionesRq:notificacionesRq){
    debugger;
     return this.http.post<any>(`https://ambiente.sigemyt.com/apiUsuario/api/GetUsuario/fechaLeido`,notificacionesRq);
  }



 
}

